/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var minilo = require('../util/minilo');

/** @module ol-ext/util */

/**
 * heuristic check that value is ol collection
 * @param value
 * @return {boolean}
 */
function isCollection(value) {
  return value && minilo.isFunction(value.getArray);
}

/**
 * heuristic check that value is ol vector source
 * @param value
 * @return {*}
 */
function isVectorSource(value) {
  return value && minilo.isFunction(value.getAttributions) && minilo.isFunction(value.getFeatureById);
}

/**
 * @param value
 * @return {*}
 */
function isCircle(value) {
  return minilo.isFunction(value.getCenter) && minilo.isFunction(value.getRadius);
}

exports.isCollection = isCollection;
exports.isVectorSource = isVectorSource;
exports.isCircle = isCircle;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/util.js
// module id = 173
// module chunks = 1